import React from "react";
import LineChart from "../../../components/LineChart/LineChart";

const LevensVerwachting = () => {
	const margin = { top: 60, right: 30, bottom: 90, left: 45 };

	const formatY = value => value;
	const formatValueTooltip = value => value + " jaar";

	const data = [
		{
			name: "vrouwen",
			values: [
				{ x: 1965, y: 76.1 },
				{ x: 1966, y: 76.1 },
				{ x: 1967, y: 76.6 },
				{ x: 1968, y: 76.4 },
				{ x: 1969, y: 76.3 },
				{ x: 1970, y: 76.5 },
				{ x: 1971, y: 76.8 },
				{ x: 1972, y: 76.8 },
				{ x: 1973, y: 77.1 },
				{ x: 1974, y: 77.6 },
				{ x: 1975, y: 77.7 },
				{ x: 1976, y: 77.9 },
				{ x: 1977, y: 78.5 },
				{ x: 1978, y: 78.5 },
				{ x: 1979, y: 78.9 },
				{ x: 1980, y: 79.2 },
				{ x: 1981, y: 79.3 },
				{ x: 1982, y: 79.4 },
				{ x: 1983, y: 79.6 },
				{ x: 1984, y: 79.7 },
				{ x: 1985, y: 79.7 },
				{ x: 1986, y: 79.6 },
				{ x: 1987, y: 80.1 },
				{ x: 1988, y: 80.2 },
				{ x: 1989, y: 79.9 },
				{ x: 1990, y: 80.1 },
				{ x: 1991, y: 80.2 },
				{ x: 1992, y: 80.3 },
				{ x: 1993, y: 80.0 },
				{ x: 1994, y: 80.3 },
				{ x: 1995, y: 80.4 },
				{ x: 1996, y: 80.4 },
				{ x: 1997, y: 80.6 },
				{ x: 1998, y: 80.7 },
				{ x: 1999, y: 80.5 },
				{ x: 2000, y: 80.6 },
				{ x: 2001, y: 80.7 },
				{ x: 2002, y: 80.7 },
				{ x: 2003, y: 80.9 },
				{ x: 2004, y: 81.4 },
				{ x: 2005, y: 81.6 },
				{ x: 2006, y: 81.9 },
				{ x: 2007, y: 82.3 },
				{ x: 2008, y: 82.3 },
				{ x: 2009, y: 82.7 },
				{ x: 2010, y: 82.7 },
				{ x: 2011, y: 82.9 },
				{ x: 2012, y: 82.8 },
				{ x: 2013, y: 83.0 },
				{ x: 2014, y: 83.3 },
				{ x: 2015, y: 83.1 },
				{ x: 2016, y: 83.1 },
				{ x: 2017, y: 83.3 },
				{ x: 2018, y: 83.5 },
				{ x: 2019, y: 83.7 },
				{ x: 2020, y: 83.9 },
				{ x: 2021, y: 84.1 },
				{ x: 2022, y: 84.3 },
				{ x: 2023, y: 84.5 },
				{ x: 2024, y: 84.7 },
				{ x: 2025, y: 84.8 },
				{ x: 2026, y: 85.0 },
				{ x: 2027, y: 85.2 },
				{ x: 2028, y: 85.3 },
				{ x: 2029, y: 85.5 },
				{ x: 2030, y: 85.7 },
				{ x: 2031, y: 85.8 },
				{ x: 2032, y: 86.0 },
				{ x: 2033, y: 86.2 },
				{ x: 2034, y: 86.4 },
				{ x: 2035, y: 86.5 }
			]
		},		{
			name: "mannen",
			values: [
				{ x: 1965, y: 71.1 },
				{ x: 1966, y: 71.0 },
				{ x: 1967, y: 71.2 },
				{ x: 1968, y: 70.9 },
				{ x: 1969, y: 70.9 },
				{ x: 1970, y: 70.8 },
				{ x: 1971, y: 71.0 },
				{ x: 1972, y: 70.8 },
				{ x: 1973, y: 71.3 },
				{ x: 1974, y: 71.6 },
				{ x: 1975, y: 71.5 },
				{ x: 1976, y: 71.5 },
				{ x: 1977, y: 72.1 },
				{ x: 1978, y: 72.0 },
				{ x: 1979, y: 72.5 },
				{ x: 1980, y: 72.5 },
				{ x: 1981, y: 72.7 },
				{ x: 1982, y: 72.7 },
				{ x: 1983, y: 72.9 },
				{ x: 1984, y: 73.0 },
				{ x: 1985, y: 73.1 },
				{ x: 1986, y: 73.1 },
				{ x: 1987, y: 73.5 },
				{ x: 1988, y: 73.7 },
				{ x: 1989, y: 73.7 },
				{ x: 1990, y: 73.8 },
				{ x: 1991, y: 74.1 },
				{ x: 1992, y: 74.3 },
				{ x: 1993, y: 74.0 },
				{ x: 1994, y: 74.6 },
				{ x: 1995, y: 74.6 },
				{ x: 1996, y: 74.7 },
				{ x: 1997, y: 75.2 },
				{ x: 1998, y: 75.2 },
				{ x: 1999, y: 75.3 },
				{ x: 2000, y: 75.5 },
				{ x: 2001, y: 75.8 },
				{ x: 2002, y: 76.0 },
				{ x: 2003, y: 76.2 },
				{ x: 2004, y: 76.9 },
				{ x: 2005, y: 77.2 },
				{ x: 2006, y: 77.6 },
				{ x: 2007, y: 78.0 },
				{ x: 2008, y: 78.3 },
				{ x: 2009, y: 78.5 },
				{ x: 2010, y: 78.8 },
				{ x: 2011, y: 79.2 },
				{ x: 2012, y: 79.1 },
				{ x: 2013, y: 79.4 },
				{ x: 2014, y: 79.9 },
				{ x: 2015, y: 79.7 },
				{ x: 2016, y: 79.9 },
				{ x: 2017, y: 80.2 },
				{ x: 2018, y: 80.5 },
				{ x: 2019, y: 80.7 },
				{ x: 2020, y: 80.9 },
				{ x: 2021, y: 81.1 },
				{ x: 2022, y: 81.3 },
				{ x: 2023, y: 81.5 },
				{ x: 2024, y: 81.6 },
				{ x: 2025, y: 81.8 },
				{ x: 2026, y: 82.0 },
				{ x: 2027, y: 82.1 },
				{ x: 2028, y: 82.3 },
				{ x: 2029, y: 82.5 },
				{ x: 2030, y: 82.6 },
				{ x: 2031, y: 82.8 },
				{ x: 2032, y: 83.0 },
				{ x: 2033, y: 83.1 },
				{ x: 2034, y: 83.3 },
				{ x: 2035, y: 83.4 }
			]
		}
	];

	return (
		<div className="vis-levensverwachting">
			<LineChart
				margin={margin}
				colorLines={["#000"]}
				colorAxis="#333"
				labelY="aantal"
				domainY={[0, 100]}
				data={data}
				height={600}
				formatY={formatY}
				formatValueTooltip={formatValueTooltip}
				startForecast={2017}
			/>

			<div className="vis-credit">
				<p>Gemiddelde levensverwachting in Nederland per geboortejaar</p>
				<p>Vanaf 2017 op basis van prognose</p>
				<p>Bron: Staat van Volksgezondheid en Zorg</p>
			</div>
		</div>
	);
};

export default LevensVerwachting;
